import { ReactNode } from 'react'

type Props = {
  className?: string
  children: ReactNode
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  disabled?: boolean
  tabIndex?: number
  type?: 'button' | 'reset' | 'submit'
}

export const Button = ({ className, children, onClick, disabled, ...props }: Props) => {
  return (
    <button
      className={`rounded-full ${disabled ? '' : 'hover:bg-opacity-70'} ${className}`}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  )
}
